/* eslint-disable no-useless-constructor */
import feathersClient, { BaseModel, makeServicePlugin } from "../../feathers-client";

class NYISORealTimePrices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "NYISORealTimePrices";
}

const servicePlugin = makeServicePlugin({
  Model: NYISORealTimePrices,
  service: feathersClient.service("data-services/nyiso/real-time-prices-generation"),
  idField: "_id",
  nameStyle: "path",
  getters: {},
});

export default servicePlugin;
